module.exports = __webpack_public_path__ + "static/media/C_A.4d13b029.png";